import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatPLN, formatDate } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then((r) => { setOrders(r.data); setLoading(false); });
  }, []);

  return (
    <div>
      <PageHeader testId="my-orders-page" title="Moje zamówienia" subtitle={`${orders.length} ${orders.length === 1 ? "zamówienie" : "zamówień"}`} />

      <div className="ol-card overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-sm text-slate-500">Ładowanie…</div>
        ) : orders.length === 0 ? (
          <div className="p-12 text-center">
            <p className="text-sm text-slate-500">Brak zamówień.</p>
            <Link to="/catalog" className="ol-link text-sm mt-2 inline-block">Złóż pierwsze zamówienie</Link>
          </div>
        ) : (
          <table className="ol-table" data-testid="my-orders-table">
            <thead>
              <tr>
                <th>Numer</th>
                <th>Złożone</th>
                <th>Pozycje</th>
                <th className="text-right">Wartość początkowa</th>
                <th className="text-right">Wartość końcowa</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}>
                  <td className="font-mono text-xs">{o.order_number}</td>
                  <td className="text-slate-600">{formatDate(o.submitted_at || o.created_at)}</td>
                  <td>{o.items?.length || 0}</td>
                  <td className="text-right">{formatPLN(o.original_total_net)}</td>
                  <td className="text-right font-semibold">{formatPLN(o.final_total_net)}</td>
                  <td><StatusBadge status={o.status} /></td>
                  <td>
                    <Link to={`/orders/${o.id}`} className="ol-link text-xs" data-testid={`view-order-${o.order_number}`}>Szczegóły</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
